import PonchoIcon from "./PonchoIcon";

export default function EmpresaEIndustriaIcon({ ...props }) {
  return <PonchoIcon name="empresas-e-industria" {...props} />;
}
